import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext, AuthProvider } from './AuthProvider.js'; 

import AdminRouting from "./Nav/AdminRouting";
import CustomerRouting from "./Nav/CustomerRouting";
import RootRouter from "./Nav/RootRouter";
import PrivateRoutes from "./Nav/PrivateRoutes";
import { PageProvider } from './Context/Pagecontxt.js';

function MainApp() {
  const { isAuthenticated, userType } = useContext(AuthContext);
  
  return (
    <PageProvider>
      <Routes>
        <Route element={<PrivateRoutes />}>
          {isAuthenticated && userType === "Admin" && (
            <Route path="/admin/*" element={<AdminRouting />} />
          )}
          {isAuthenticated && userType === "Customer" && (
            <Route path="/customer/*" element={<CustomerRouting />} />
          )}
        </Route>
        <Route path="/*" element={<RootRouter />} />
      </Routes>
    </PageProvider>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <MainApp />
      </AuthProvider>
    </Router>
  );
}

export default App;